import ajax from '@/utils/ajax';
import ProcessedUpload from '@/Types/ProcessedUpload';

const MAX_PERCENT = 90
// @ts-ignore
const {route} = global;

export interface FileWithUrl extends File {
    url?: string
}

export type FormulateUploader = (
    file: FileWithUrl,
    progress: (percent: number) => void,
    error: (error: string) => void,
) => Promise<ProcessedUpload | void>

const formulateUploaderFactory = (
    field: string,
): FormulateUploader => async (
    file: FileWithUrl,
    progress: (percent: number) => void,
    error: (error: string) => void,
) => {
    const url = route('upload');
    let percent = 0;
    progress(percent)
    const formData = new FormData();
    formData.append('file', file);
    formData.append('field', field);

    const interval = setInterval(() => progress(percent++ < MAX_PERCENT ? percent : MAX_PERCENT), 500)

    try {
        const response: { path: string } = await ajax.post(
            url,
            {
                body: formData,
            },
        ).json()

        clearInterval(interval);
        progress(MAX_PERCENT);

        file.url = response.path;

        setTimeout(() => {
            progress(100);
        }, 1000)

        return <ProcessedUpload>{
            name: file.name,
            url: file.url,
        };
    } catch (e: any) {
        error(e.message)
        return;
    }
}

export default formulateUploaderFactory
